import React, { useEffect, useState, useRef } from 'react';
// import fffLogo from '/assets/FFF_logo.svg'

import './App.css';
import { GuideButton, GuideData, GuideNode } from './model/types';

function App() {
  const [showB, setShowB] = useState(false);
  const [guideData, setGuideData] = useState<GuideData>();
  const [currentNode, setCurrentNode] = useState<GuideNode>();

  const [imageForA, setImageForA] = useState<string>();
  const [imageForB, setImageForB] = useState<string>();

  useEffect(() => {
    fetch('https://snowpaw.oss-cn-hangzhou.aliyuncs.com/anji/navigation/navigate.json')
      .then(response => {
        if (!response.ok) throw new Error('请求失败');
        return response.json();
      })
      .then(jsonData => {
        const data = jsonData as GuideData;
        setGuideData(data);
        const rootNode = data.ids.find(node => node.id === data.rootId);
        if (rootNode) {
          setCurrentNode(rootNode);
          setImageForA(rootNode.imgSrc);
          scrollToCenter(false);
        }
      })
      .catch(error => {
        console.error('请求失败:', error);
      })
  }, [])

  const xhrRef: any = useRef(null);

  const scrollToCenter = (isShowB: boolean) => {
    const targetDiv = document.getElementById(isShowB ? "imageContainerB" : "imageContainerA");
    const appDiv = document.getElementById('App');
    if (targetDiv && appDiv) {
      const middle = (targetDiv.scrollWidth - appDiv.clientWidth) / 2;
      targetDiv.scrollLeft = middle; // 直接滚动
    }
  }

  // 预加载图片并跟踪进度
  const loadImage = (url: string) => {
    return new Promise((resolve, reject) => {

      // 使用 XMLHttpRequest 来跟踪加载进度
      xhrRef.current = new XMLHttpRequest();
      xhrRef.current.open('GET', url, true);
      xhrRef.current.responseType = 'blob';

      xhrRef.current.onprogress = (e: any) => {
        // if (e.lengthComputable) {
        // const percent = (e.loaded / e.total) * 100;
        // setProgress(percent);
        // }
      };

      xhrRef.current.onload = () => {
        if (xhrRef.current.status === 200) {
          const blob = xhrRef.current.response;
          const imgUrl = URL.createObjectURL(blob);
          resolve(imgUrl);
        }
      };

      xhrRef.current.onerror = () => {
        // reject(new Error('Image load failed'));
        // setIsLoading(false);
      };

      xhrRef.current.send();
    });
  };

  const handleClick = async (e: any) => {
    // const clickedDiv = e.currentTarget;
    // console.log('触发的 div ID:', clickedDiv.id);

    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;  // 相对于 div 左上角的 X 坐标
    const y = e.clientY - rect.top;   // 相对于 div 左上角的 Y 坐标
    const normalizedX = x / rect.width;   // 归一化为 0-1
    const normalizedY = y / rect.height;  // 归一化为 0-1

    var clickecNode: GuideButton | undefined = undefined;

    if (currentNode) {
      for (const button of currentNode.buttons) {
        if (button.screenPosition.startX <= normalizedX
          && normalizedX <= button.screenPosition.endX
          && button.screenPosition.startY <= normalizedY
          && normalizedY <= button.screenPosition.endY) {
          // 点击了按钮
          clickecNode = button;
        }
      }
    }

    if (clickecNode !== undefined && guideData !== undefined) {
      // 点击了按钮

      const targetNode = guideData.ids.find(node => node.id === clickecNode?.targetId);
      if (targetNode) {
        const image = await loadImage(targetNode.imgSrc);
        if (!showB) {
          setImageForB(image as string);
        } else {
          setImageForA(image as string);
        }
        setCurrentNode(targetNode);
        setShowB(!showB);
        scrollToCenter(!showB);
      }
    }
  };

  return (
    <div className="App" id='App'>
      <div id='imageContainerA'
        className='guide-images-container'
        onClick={handleClick}
        style={{
          opacity: showB ? 0 : 1,
          zIndex: 0,
          transition: 'opacity 0.75s ease-in-out',
          pointerEvents: showB ? 'none' : 'auto'
        }}
      >
        <img id='imageA' src={imageForA} alt=''
          className='guide-images' />

        {/* {
            currentNode?.buttons.map((button,index) => {
              return (
                <div 
                  id={button.targetId}
                  key={index}
                  className='guide-button-container'
                  style={{
                    top: button.screenPosition.x * 100 + '%',
                    left: button.screenPosition.y * 100 + '%',
                  }}
                  onClick={handleClick}>
                    <img src={getIconFromType(button.type)} alt={button.type} className='guide-button-icon'/>
                    <div className='guide-button-text'>{button.text}</div>
                </div> 
              );
            })
          } */}
      </div>

      <div id='imageContainerB'
        className='guide-images-container'
        onClick={handleClick}
        style={{
          opacity: showB ? 1 : 0,
          zIndex: 1,
          transition: 'opacity 0.75s ease-in-out',
          pointerEvents: showB ? 'auto' : 'none'
        }} >
        <img id='imageB' src={imageForB} alt=''
          className='guide-images' />
      </div>


      <div className='overlay'>
        <div className='mask' />
        <div className='fff-logo' />
      </div>
    </div>
  );
}

export default App;
